import { PRODUCTS } from 'bundles/enterprise-legacy-learner-home/constants/xdpConstants';

const getProductId = (productType: string, id?: string) => {
  if (productType === 'specialization') {
    return `${PRODUCTS.specialization}~${id?.replace('child~', 'child!~')}`;
  } else {
    return `${PRODUCTS.course}~${id}`;
  }
};

export default getProductId;
